import React from 'react';
import styled from 'styled-components';

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: ${(props) => props.theme.spacing(2)} 0;

  label {
    margin-left: 10px;
    font-size: 16px;
  }

  input[type='checkbox'] {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
`;

const Checkbox = ({ label, checked, onChange, ...props }) => {
  return (
    <CheckboxWrapper>
      <input type="checkbox" checked={checked} onChange={onChange}  {...props} />
      <label>{label}</label>
    </CheckboxWrapper>
  );
};

export default Checkbox;
